import PropTypes from 'prop-types';

import ActionButton from './ActionButton';

import { useSessionManagement } from '../hooks/useSession';

const LoginButton = ({ classes }) => {
  const { signIn } = useSessionManagement();

  return <ActionButton label="login" variant="contained" classes={classes} onClick={signIn} />;
};

LoginButton.propTypes = {
  classes: PropTypes.object,
};

LoginButton.defaultProps = {
  classes: {},
};

export default LoginButton;
